import { render } from "./TeacherClassesSelectPopupItem.vue?vue&type=template&id=7b06093a&scoped=true&ts=true"
import script from "./TeacherClassesSelectPopupItem.vue?vue&type=script&lang=ts"
export * from "./TeacherClassesSelectPopupItem.vue?vue&type=script&lang=ts"

import "./TeacherClassesSelectPopupItem.vue?vue&type=style&index=0&id=7b06093a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b06093a"]])

export default __exports__